import { handlePaginatedData } from '../services/DataHelperFunctions';
import { EAction, EActionType, EApiType, EUrlParams } from '../data/Constants';
import AxiosClient from './AxiosClient';
import { handleSuccess, handleError, handleApiErrorWithFallback } from './HttpUtil';
import type { Dispatch } from '@reduxjs/toolkit';

import type { IError } from '../../types';
import type { IDeleteRequest, IPaginationRequest, IStringResponse } from '../../types/IApiTypes';

export const NotificationApi = {
  //get all notifications from the api
  getNotifications: (payload: IPaginationRequest, dispatch: Dispatch) => {
    let queryParams = new URLSearchParams();
    if (payload.caller !== EActionType.Refresh) {
      queryParams = new URLSearchParams({
        [EUrlParams.Page]: String(payload.page),
        [EUrlParams.Limit]: String(payload.limit),
      });
    }
    if (payload.searchCode) {
      queryParams.set(EUrlParams.Search, payload.searchCode);
    }
    return AxiosClient.post(`/notification/v1/read?${queryParams}`, {})
      .then((response) => {
        return handlePaginatedData(response, payload);
      })
      .catch((err) => {
        return handleApiErrorWithFallback(
          dispatch,
          err,
          { page: payload.page, searchKey: payload.searchCode, caller: payload.caller },
          EAction.Read,
          EApiType.NotificationKey
        );
      });
  },

  //soft delete the existing notification(s)
  deleteNotification: async (action: IDeleteRequest, dispatch: Dispatch) => {
    return AxiosClient.post('/notification/v1/delete', action.request)
      .then((response: IStringResponse) => {
        return handleSuccess(response);
      })
      .catch((err: IError) => {
        return handleError(dispatch, err);
      });
  },

  //retrigger existing notification
  retriggerNotification: async (id: string, dispatch: Dispatch) => {
    return AxiosClient.post(`/producer/v1/notification/retrigger?notificationId=${id}`, {})
      .then((response: IStringResponse) => {
        return handleSuccess(response);
      })
      .catch((err: IError) => {
        return handleError(dispatch, err, EAction.Retrigger);
      });
  },
};
